import ThreadPagination from './ThreadPagination';
import ThreadPaginationContainer from './ThreadPagination.container';
export default ThreadPaginationContainer(ThreadPagination);
